import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
export default function DropdownListItem(props) {
  var classes = classNames({
    'hard--sides': props.hardSides,
    'hard--top': props.hardTop,
    'oui-dropdown__item': true
  });
  return React.createElement("li", {
    className: classes
  }, props.children);
}
DropdownListItem.propTypes = {
  /** Nodes to display within */
  children: PropTypes.node,

  /** Remove padding from sides */
  hardSides: PropTypes.bool,

  /** Remove padding from top */
  hardTop: PropTypes.bool
};